import { render, staticRenderFns } from "./ConfigEarlyRightWarning.vue?vue&type=template&id=af3191aa&scoped=true"
import script from "./ConfigEarlyRightWarning.vue?vue&type=script&lang=ts"
export * from "./ConfigEarlyRightWarning.vue?vue&type=script&lang=ts"
import style0 from "./ConfigEarlyRightWarning.vue?vue&type=style&index=0&id=af3191aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3191aa",
  null
  
)

export default component.exports